import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-form-field',
  templateUrl: 'form-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldComponent extends UIKitBaseComponent {
  // @ts-expect-error
  @Input() invalid: boolean;
  // @ts-expect-error
  @Input() label: string;
}
